import {
  closeCommentAtom,
  focusedThreadAtom,
  openCommentAtom,
  type OpenCommentState,
} from 'atoms/comment';
import {useSetAtom} from 'jotai';
import {useCallback} from 'react';

export const useCommentActions = () => {
  const openActiveComment = useSetAtom(openCommentAtom);
  const closeActiveComment = useSetAtom(closeCommentAtom);
  const setFocusedThread = useSetAtom(focusedThreadAtom);

  const openComment = useCallback(
    (comment: OpenCommentState) => {
      const didOpen = openActiveComment(comment);
      if (!didOpen) return false;

      setFocusedThread(comment.threadId);
      return true;
    },
    [openActiveComment, setFocusedThread]
  );

  const closeComment = useCallback(() => {
    const didClose = closeActiveComment();
    if (!didClose) return false;

    setFocusedThread(undefined);
    return true;
  }, [closeActiveComment, setFocusedThread]);

  return {openComment, closeComment};
};
